const app = {
  // Manage seed view
  seeds: {
    index: {
      title: "Seed List",
      noResults: "No seeds found",
      subtitle: "Seed Addresses",
      description: "Here's a list of all the seed addresses on the seed list.",
    },
    // Add seed form
    addSeedForm: {
      title: "Add Seed",
      successMessage: "Seed address successfully created.",
    },
    // Edit seed form
    editSeedForm: {
      title: "Edit Seed",
      successMessage: "Seed address successfully updated.",
    },
    // Delete seed
    deleteSeed: {
      title: `Delete '<<email>>'`,
      subtitle: "This seed address is about to be permanently deleted.",
      successMessage: "Seed address successfully deleted.",
    },
    // Archive seed
    disableSeed: {
      title: `Archive ‘<<email>>’`,
      subTitle: "This seed address is about to be archived.",
      successMessage: "Seed address was successfully archived.",
    },
    enableSeed: {
      title: `Re-activate ‘<<email>>’`,
      subTitle: "This seed address is about to be re-activated.",
      successMessage: "Seed address successfully re-activated.",
    },
  },
  // Account view
  account: {
    index: {
      // View title
      title: "Accounts",
      noResults: "No accounts found",
    },
    create: {
      title: "Add Account",
      // Account form
      addAccountForm: {
        title: "Account Information",
        successMsg: "Account successfully added",
      },
    },
    update: {
      title: "Edit",
      editAccountForm: {
        title: "Account Information",
        successMsg: "Account successfully updated",
      },
    },
  },
  // Accounts index page
  accounts: {
    index: {
      title: "Accounts",
    },
  },
  // Customer view
  customers: {
    index: {
      title: "Customers",
      noResults: "No customers found",
      trailingHistoryTitle: "6 Month Trailing Usage",
    },
    // Create customer view
    create: {
      title: "Add Customer",
      customerTitle: "Customer Information",
      subscriptionTitle: "Subscription Information",
      successMsg: "Customer successfully created",
      errorMsg: "Customer could not be added. Please try again.",
    },
    // Update customer view
    update: {
      successMsg: "Customer information changes was successfully saved.",
      subscriptionSuccessMsg:
        "Subscription information was successfully saved.",
      errorMsg:
        "Customer information changes could not be saved. Please try again.",
    },
    // Disable account dialog config
    disableAccount: {
      title: "Disable ‘{{name}}’",
      subTitle: "This account will be disabled.",
      successMsg: "Account was disabled successfully.",
    },
    // Customer owners tab config
    owner: {
      title: "Owners",
      drawerTitle: "Add Owner",
      // Delete user customer access dialog
      deleteAccess: {
        title: "Delete ‘{{name}}’",
        multipleTitle: "Delete Owner",
        subTitle:
          "This user will no longer have owner access to this Customer.",
        successMsg: "Owner was successfully deleted.",
      },
      addAccess: {
        successMsg: "Owner was successfully added.",
      },
    },
  },
  // Login form
  loginForm: {
    subTitle: "ADMIN PANEL",
    // Error message
    invalidUserMsg: "The email or password you entered is incorrect.",
  },

  // Users
  manageUsers: {
    index: {
      title: "Users",
      noResults: "No users found.",
    },
    // User details page
    user: {
      title: "User Information",
      // Accounts tab
      accountAccess: {
        title: "Users",
        deleteUser: {
          singleUser: "Delete ‘{{email}}’",
          title: "Delete <<count>> Users",
          subTitle: "This user will no longer have access to this account.",
          successMsg: "User was successfully deleted.",
        },
        // Add user membership accounts
        addUserAccounts: {
          successMsg: "Users were successfully added.",
        },
        // Update user membership access
        updateUser: {
          title: "Change ‘{{accountName}}’ Role",
          multipleTitle: "Change Roles",
          subTitle:
            "These users will now have {{roleName}} access to this account.",
          successMsg: "Role changes were successfully saved.",
        },
      },
      // Customers tab
      customers: {
        title: "Customers",
        subTitle: "Add Customer",
        alertMessage: `Owners manage the customer record, and can add other owners, create accounts, and access admin features for all customer accounts.`,
        successMsg: "Customer was successfully added.",

        // Delete user customer access dialog
        deleteAccess: {
          title: "Delete ‘{{name}}’",
          multipleTitle: "Delete Customers",
          subTitle:
            "This user will no longer have owner access to this customer.",
          successMsg: "Customer was successfully deleted.",
        },
      },
    },
    // Accounts tab
    accounts: {
      title: "Accounts",
    },
    // Add user form
    addUserForm: {
      title: "Add User",
      userAccessHint:
        "User can view and download reports for the selected accounts.",
      successMsg: "A user '<<name>>' created successfully.",
    },
    // Delete user dialog
    deleteUser: {
      title: "Delete ‘<<name>>’",
      subTitle: "This user will no longer have access to any accounts.",
      successMsg: "User <<name>> deleted successfully.",
    },
    // Edit user permission
    editPermission: {
      title: "Edit Permissions",
      successMsg: "User <<name>> permissions updated successfully.",
    },
  },
  // Manage Mailbox providers
  mailboxProvider: {
    index: { title: "Mailbox Providers" },
    // Delete mailbox provider config
    deleteMailbox: {
      title: `Delete ‘<<mailbox>>’`,
      subTitle: "This mailbox provider is about to be permanently deleted.",
      successMsg: "Mailbox provider was successfully deleted.",
    },
    // Add mailbox drawer
    addMailbox: {
      title: "Add Mailbox Provider",
      formTitle: "Mailbox Provider Information",
      successMsg: "Mailbox provider was successfully added.",
      duplicateMailbox: "Mailbox Provider already exists.",
    },
    // Update mailbox drawer
    updateMailbox: {
      title: "Update Mailbox Provider",
      successMsg: "Mailbox provider changes were successfully saved.",
    },
  },
  /** Logged out view */
  loggedOut: {
    title: "Logged Out Successfully!",
  },
  // Error logs index page
  errorLogs: {
    index: {
      title: "Error logs",
    },
  },
  // Common form input field messages
  common: {
    mailboxProvider: {
      noData: "No mailbox providers available",
      loading: "Loading mailbox providers...",
    },
    accounts: {
      noData: "No accounts available",
      loading: "Loading accounts...",
    },
    roles: {
      noData: "No roles available",
      loading: "Loading roles...",
    },
    seeds: {
      loading: "Loading seeds...",
    },
    users: {
      loading: "Loading users...",
      noData: "No users available",
    },
    customers: {
      noData: "No customers available",
      loading: "Loading customers...",
    },
    regions: {
      noData: "No regions available",
      loading: "Loading regions...",
    },
    errorLogs: {
      noData: "No error logs available",
      loading: "Loading error logs...",
    },
  },
};

export default Object.freeze(app);
